<template>
	<div class="dt-companies-add-new">
		<el-button text @click="AddNewCompanyDialog = true" class="add-new-company">
			<span>
				<AddPlusIcon icon-color="fill-dark_cyan" />
			</span>
			<span>Add new company</span>
		</el-button>
		<el-form v-if="AddNewCompanyDialog" accept="" method="POST">
			<el-dialog align-center v-model="AddNewCompanyDialog" title="Request a new company" modal-class="add-new-company-popups">
				<el-form-item label="Company Name">
					<el-input v-model="form.name" maxlength="250" show-word-limit placeholder="Company name" />
					<!--<span v-if="form.errors" class="text-danger">{{ form.errors.name }}</span> -->
				</el-form-item>
				<el-form-item label="Company URL">
					<el-input v-model="form.url" maxlength="250" show-word-limit placeholder="Company url" />
					<!-- <span v-if="form.errors" class="text-danger">{{ form.errors.url }}</span> -->
				</el-form-item>
				<template #footer>
					<div class="flex items-center gap-x-[10px]">
						<el-button text native-type="submit" class="zf-button-dark-cyan">Submit Request</el-button>
						<el-button text class="zf-button-gray" @click="AddNewCompanyDialog = false">Cancel</el-button>
					</div>
				</template>
			</el-dialog>
		</el-form>
	</div>
</template>

<script lang="js" setup>
import AddPlusIcon from "@/components/Svg/AddPlusIcon.vue";
import { reactive, ref } from "vue";

const AddNewCompanyDialog = ref(false);

const form = reactive({
	name: "",
	url: "",
});
</script>
